import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useAtom, useSetAtom } from 'jotai';
import Loading from '../../Components/Loading';
import { logoutUserAtom, dataUserAtom, authUserAtom, isAuthAtom, userRoleAtom, darkModeAtom } from '../../Services/store/atoms';
import { resetTemporaryAtom } from '../../Services/store/atoms';
import DashboardLayout from '../../Layouts/DashboardLayout';
import { useIsInDashboard } from '../../Layouts/DashboardContext';
import { PiBellFill, PiBellLight, PiChartBarFill, PiChartBarLight, PiChatCircleFill, PiChatCircleLight, PiChatsCircleFill, PiChatsCircleLight, PiClipboardTextFill, PiClipboardTextLight, PiCoinsFill, PiCoinsLight, PiCreditCardFill, PiCreditCardLight, PiDevicesFill, PiDevicesLight, PiEnvelopeSimpleFill, PiEnvelopeSimpleLight, PiFlagFill, PiFlagLight, PiFlaskFill, PiFlaskLight, PiGlobeFill, PiGlobeLight, PiHeartFill, PiHeartLight, PiHouseFill, PiHouseLight, PiIdentificationCardFill, PiIdentificationCardLight, PiImageFill, PiImageLight, PiKeyFill, PiKeyLight, PiLinkFill, PiLinkLight, PiMagnifyingGlassBold, PiMagnifyingGlassFill, PiMagnifyingGlassLight, PiNewspaperFill, PiNewspaperLight, PiPackageFill, PiPackageLight, PiPlusBold, PiProhibitBold, PiSealCheckFill, PiSealCheckLight, PiSealWarningFill, PiSealWarningLight, PiShareNetworkFill, PiShareNetworkLight, PiSignInLight, PiSignOutLight, PiSparkleFill, PiSparkleLight, PiThumbsUpFill, PiThumbsUpLight, PiTrendUpFill, PiTrendUpLight, PiUserCircleFill, PiUserCircleLight, PiUserGearFill, PiUserGearLight, PiUserMinusFill, PiUserMinusLight, PiUsersFill, PiUsersLight } from 'react-icons/pi';
import { navIcon, navIconBadged } from '../../Components/SideBar/navIcon';
import SideBarMenuItem from '../../Components/SideBar/SideBarMenuItem';
import SideBarVisionModeToggle from '../../Components/SideBarVisionModeToggle';

function LayoutHomeUser(props) {
    const isInDashboard = useIsInDashboard();
    const history = useHistory();
    const [dataUser] = useAtom(dataUserAtom);
    const [isAuth] = useAtom(isAuthAtom);
    const [darkMode] = useAtom(darkModeAtom);
    const logoutUser = useSetAtom(logoutUserAtom);
    const resetTemporary = useSetAtom(resetTemporaryAtom);
    const [isLoading, setIsLoading] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

    const isAdmin = Boolean(isAuth && dataUser && dataUser.role === 'admin');

    if (isInDashboard) return <>{props.children}</>;

    const logout = async () => {
        console.log('Logout function called');
        console.log('Before logout - isAuth:', isAuth, 'dataUser:', dataUser);
        await logoutUser();
        resetTemporary();
        history.push('/');
        console.log('After logout - isAuth:', isAuth, 'dataUser:', dataUser);
    };

    const [userRole] = useAtom(userRoleAtom);
    const [authUser] = useAtom(authUserAtom);
    const role = userRole || authUser?.role || 'admin';

    const links = [
        {
            label: 'General',
            items: [
                // Para el admin, /admin es la cola de cuentas por verificar: ya está en Verificación.
                ...(isAdmin ? [] : [{ title: 'Inicio', ...navIcon(PiHouseLight, PiHouseFill), url: isAuth ? `/${role}` : '/' }]),
                { title: 'Modelos', ...navIcon(PiUsersLight, PiUsersFill), url: isAuth ? `/${role}/models` : '/', translate: 'no' },
                { title: 'Packs', ...navIcon(PiPackageLight, PiPackageFill), url: isAuth ? `/${role}/packs` : '/packs', translate: 'no' },
                { title: 'Feed', ...navIcon(PiNewspaperLight, PiNewspaperFill), url: isAuth ? `/${role}/feed` : '/feed', translate: 'no' },
            ],
        },
    ];

    // Solo mostrar opciones de gestión si es usuario autenticado como admin.
    // Ordenado por tarea: primero las colas del día (verificación y moderación),
    // después la operación y al final lo que se usa poco.
    if (isAdmin) {
        links.push({
            label: 'Verificación',
            items: [
                { title: 'Cuentas por verificar', ...navIcon(PiClipboardTextLight, PiClipboardTextFill), url: `/${role}`, translate: 'no', keywords: 'inicio home registro' },
                { title: 'Documentos actualizados', ...navIcon(PiIdentificationCardLight, PiIdentificationCardFill), url: `/${role}/documentUpdates`, translate: 'no', keywords: 'identidad dni' },
                { title: 'Perfiles por verificar', ...navIcon(PiUserCircleLight, PiUserCircleFill), url: `/${role}/listprofilesverify`, translate: 'no', keywords: 'fotos portada profiles' },
                { title: 'Packs por verificar', ...navIconBadged(PiPackageLight, PiPackageFill, PiMagnifyingGlassBold), url: `/${role}/listpacksverify`, translate: 'no' },
                { title: 'Publicaciones en revisión', ...navIcon(PiImageLight, PiImageFill), url: `/${role}/feed-review`, translate: 'no', keywords: 'feed posts' },
                { title: 'Cuentas aprobadas', ...navIcon(PiSealCheckLight, PiSealCheckFill), url: `/${role}/verifyApprove`, translate: 'no' },
                { title: 'Cuentas fallidas', ...navIcon(PiSealWarningLight, PiSealWarningFill), url: `/${role}/verifyFail`, translate: 'no', keywords: 'rechazadas' },
            ],
        });
        links.push({
            label: 'Moderación',
            items: [
                { title: 'Imágenes bloqueadas', ...navIconBadged(PiImageLight, PiImageFill, PiProhibitBold), url: `/${role}/image-moderations`, translate: 'no' },
                { title: 'Reclamos del chat', ...navIcon(PiFlagLight, PiFlagFill), url: `/${role}/chat-claims`, translate: 'no', keywords: 'denuncias reportes' },
                { title: 'Alertas de bloqueo', ...navIcon(PiUserMinusLight, PiUserMinusFill), url: `/${role}/block-alerts`, translate: 'no' },
                { title: 'Conversaciones', ...navIcon(PiChatsCircleLight, PiChatsCircleFill), url: `/${role}/conversations`, translate: 'no', keywords: 'chats mensajes' },
                { title: 'Avisos de compatibilidad', ...navIcon(PiHeartLight, PiHeartFill), url: `/${role}/match-notices`, translate: 'no', keywords: 'match' },
            ],
        });
        links.push({
            label: 'Contenido',
            items: [
                { title: 'Lo nuevo', ...navIcon(PiSparkleLight, PiSparkleFill), url: `/${role}/whatsnew`, translate: 'no', keywords: 'galerías feeds recientes' },
                { title: 'Subir pack', ...navIconBadged(PiPackageLight, PiPackageFill, PiPlusBold), url: `/${role}/uploadPack`, translate: 'no' },
                { title: 'Buscar modelos', ...navIcon(PiMagnifyingGlassLight, PiMagnifyingGlassFill), url: `/${role}/searchPacks`, translate: 'no' },
            ],
        });
        links.push({
            label: 'Ventas',
            items: [
                { title: 'Ventas de modelos', ...navIcon(PiTrendUpLight, PiTrendUpFill), url: `/${role}/modelsales`, translate: 'no', keywords: 'pagos ganancias' },
                { title: 'Compras de packs', ...navIcon(PiCoinsLight, PiCoinsFill), url: `/${role}/pack-purchases`, translate: 'no' },
                { title: 'Recargas de usuarios', ...navIcon(PiCreditCardLight, PiCreditCardFill), url: `/${role}/user-recharges`, translate: 'no', keywords: 'coins monedas' },
                { title: 'Estadísticas', ...navIcon(PiChartBarLight, PiChartBarFill), url: `/${role}/stats`, translate: 'no', keywords: 'métricas stats' },
            ],
        });
        links.push({
            label: 'Marketing',
            items: [
                { title: 'Campañas de email', ...navIcon(PiEnvelopeSimpleLight, PiEnvelopeSimpleFill), url: `/${role}/email-campaigns`, translate: 'no', keywords: 'correo mail' },
                { title: 'Links de referidos', ...navIcon(PiLinkLight, PiLinkFill), url: `/${role}/referrals`, translate: 'no' },
                { title: 'Compartir modelos', ...navIcon(PiShareNetworkLight, PiShareNetworkFill), url: `/${role}/shareModels`, translate: 'no' },
                { title: 'Minar likes', ...navIcon(PiThumbsUpLight, PiThumbsUpFill), url: `/${role}/FeedPublicFake`, translate: 'no' },
            ],
        });
        links.push({
            label: 'Usuarios y soporte',
            items: [
                { title: 'Gestión de usuarios', ...navIcon(PiUserGearLight, PiUserGearFill), url: `/${role}/userManagement`, translate: 'no', keywords: 'cuentas editar' },
                { title: 'Chat', ...navIcon(PiChatCircleLight, PiChatCircleFill), url: `/${role}/chat`, translate: 'no', keywords: 'mensajes soporte' },
            ],
        });
        links.push({
            label: 'Configuración',
            items: [
                { title: 'Bloqueo de países', ...navIcon(PiGlobeLight, PiGlobeFill), url: `/${role}/countryBlocking`, translate: 'no' },
                { title: 'Herramientas de prueba', ...navIcon(PiFlaskLight, PiFlaskFill), url: `/${role}/test-tools`, translate: 'no', keywords: 'test coins' },
            ],
        });
    }

    // Enlace global para toda cuenta autenticada (admin y assistant incluidos)
    if (isAuth) {
        links.push({
            label: 'Cuenta',
            items: [
                ...(isAdmin ? [{ title: 'Cambiar contraseña', ...navIcon(PiKeyLight, PiKeyFill), url: `/${role}/passwordChange`, translate: 'no' }] : []),
                { title: 'Sesiones activas', ...navIcon(PiDevicesLight, PiDevicesFill), url: `/${role}/sessions`, translate: 'no' },
                { title: 'Notificaciones', ...navIcon(PiBellLight, PiBellFill), url: `/${role}/settings/notifications`, translate: 'no' },
            ],
        });
    }

    const sidebarFooter = (
        <>
            {isAdmin && <SideBarVisionModeToggle />}
            {isAuth ? (
                <SideBarMenuItem
                    title="Cerrar Sesión"
                    icon={<PiSignOutLight className="text-xl" />}
                    onClick={() => setShowLogoutConfirm(true)}
                    variant="footer"
                    tone="danger"
                />
            ) : (
                <SideBarMenuItem
                    title="Iniciar Sesión"
                    icon={<PiSignInLight className="text-xl" />}
                    url="/login"
                    variant="footer"
                    tone="accent"
                />
            )}
        </>
    );

    return (
        <>
            {isLoading && <Loading />}
            <DashboardLayout
                title={props.title}
                links={links}
                searchable={isAdmin}
                sidebarFooter={sidebarFooter}
                hideSidebar={props.hideSidebar}
                logoutConfirmation={{
                    show: showLogoutConfirm,
                    onOpen: () => setShowLogoutConfirm(true),
                    onConfirm: () => { setShowLogoutConfirm(false); logout(); },
                    onCancel: () => setShowLogoutConfirm(false),
                }}
            >
                {props.children}
            </DashboardLayout>
        </>
    );
}

export default LayoutHomeUser;
